import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { FolderOpenLightSVG } from '@common_components/svg/folderOpenLight.svg';

const FolderOpenLightIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <FolderOpenLightSVG/>
    </div>
  );
};

export { FolderOpenLightIcon };
